import styled from 'styled-components';

export const Svg = styled.svg`
  margin-left: 1rem;
  padding-left: 1rem;
`;
